<template>
    <modal size="lg" @close="reset(); $emit('close')" :height-max="true" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Add Pay Group</h3>
        </template>

        <slot>
            <div v-show="step == 'paygroup'">
                <paygroup-form
                    ref="paygroupForm"
                    :initial-value="formData.paygroup"
                />
            </div>

            <div v-if="step == 'companies'">
                <company-selector
                    :client="client"
                    :companies="client.companies"
                    v-model="formData.companies"
                />
            </div>
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button v-if="step == 'paygroup'" type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>
                <button v-if="['companies'].includes(step)" type="button" class="btn btn-outline-primary" @click.prevent="previousStep">
                    Back
                </button>
                <button v-if="['paygroup'].includes(step)" type="button" class="btn btn-primary" @click.prevent="nextStep">
                    Next
                </button>

                <button v-if="step == 'companies'" type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import PaygroupForm from './PaygroupForm'
import CompanySelector from '@/pages/client/Settings/components/CompanySelector'

export default {
    props: ['client', ],
    mixins: [FormMixin, ModalMixin],
    components: {PaygroupForm, CompanySelector, },
    emits: ['updated', 'close', ],
    mounted() {
    },
    data() {
        return {
            formData: this.makeFormData(),
            step: 'paygroup',
        }
    },
    computed: {
        companyOptions() {
            const result = []
            this.client.companies.forEach(c => {
                result.push({text: c.name, value: c.id})
            })

            result.sort((a, b) => a.text.localeCompare(b.text))
            return result
        },
    },
    methods: {
        makeFormData() {
            return {
                paygroup: {
                    name: '',
                    pay_schedule: '',
                    period_start: '',
                    period_end: '',
                    check_date_offset_1: '',
                    check_date_offset_2: '',
                    bank_holiday_treatment: '',
                    weekend_treatment: '',
                },
                companies: [],
            }
        },
        previousStep() {
            if (this.step == 'companies') {
                this.step = 'paygroup'
            }
        },
        nextStep() {
            this.formErrors = []

            if (this.step == 'paygroup') {
                if (!this.$refs.paygroupForm.validate()) {
                    this.formErrors = this.$refs.paygroupForm.formErrors
                    return
                }

                this.formData.paygroup = this.$refs.paygroupForm.getFormData()
                this.step = 'companies'
            }
        },
        onSubmit() {
            if (!this.validate()) {
                return
            }

            const data = this.getFormData()
            if (!data.companies.length) {
                this.formErrors = ['Select at least one company for this pay group.']
                return
            }

            this.$store.dispatch('START_LOADING')
            const url = `/clients/${this.client.id}/settings/paygroups`
            this.$api.post(url, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo(`Successfully added ${resp.length} pay groups.`)
                this.$emit('updated')
                this.close()
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.formErrors = (errors.__all__ || [])
                this.$bus.showError(errors.__all__)
            })
        }
    }
}
</script>
